package ru.chm.gradereport.ui.screens.home

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import ru.chm.gradereport.ui.theme.GradeTheme
import androidx.compose.ui.unit.dp
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.AppTextField
import ru.chm.gradereport.ui.components.PrimaryButton

@Composable
internal fun CreateCourseCard(
    name: String,
    onNameChange: (String) -> Unit,
    description: String,
    onDescriptionChange: (String) -> Unit,
    onCreate: () -> Unit,
) {
    AppCard(modifier = Modifier.fillMaxWidth().padding(bottom = 16.dp)) {
        Text("Создать курс", color = GradeTheme.colors.textPrimary, fontWeight = FontWeight.SemiBold)
        AppTextField(name, onNameChange, "Название", modifier = Modifier.padding(top = 8.dp))
        AppTextField(description, onDescriptionChange, "Описание", modifier = Modifier.padding(top = 8.dp))
        PrimaryButton(
            "+ Создать",
            enabled = name.isNotBlank(),
            onClick = onCreate,
            modifier = Modifier.padding(top = 12.dp),
        )
    }
}
